import { DATE_FORMAT } from '../constants/date';
import { CustomDatePipe } from '../pipes/custom-date.pipe';
import { RowMapper } from '../utils/row-mapper';
import { Biometric } from './biometric';
import { ConditionRegistry } from './condition-registry';
import { EntityContactInformation } from './entity-contact-information';
import { Individual } from './individual';
import { MemberEligibility } from './member-eligibility';
import { PatientCareGiver } from './patient-care-giver';
import { PatientCareManager } from './patient-care-manager';
import { PatientEncounterForm } from './patient-encounter-form';
import { PatientExternalAgencyUsers } from './patient-external-agency-user';
import { PatientProvider } from './patient-provider';
import { PatientRisk } from './patient-risk';

export class Patient extends Individual {
  memberId: string;
  displayId: string;
  healthplanId: string;
  medicareId: string;
  medicaidId: string;
  subscriberid: string;
  entitycontactinfo: EntityContactInformation;
  patientcareGiver: PatientCareGiver[];
  patientcareCoordinator: PatientCareManager[];
  patientExternalAgencyUsers: PatientExternalAgencyUsers[];
  entityContactInformationForm: EntityContactInformation;
  biometric: Biometric;
  encounterForm: PatientEncounterForm;
  currentstatus: PatientStatus;
  conditions: ConditionRegistry[];
  eligibility: MemberEligibility[];
  provideraffiliations: PatientProvider[];
  patientRisk: PatientRisk;
  population: string;
  eligibilitystatus: PatientEligibilityStatus;
  reason: string;
  cob: string;
  pmRiskScore: string;
  donScore: string;
  mhnScore: string;
  ccasScore: string;
  memberMasterStatus: string;
  insurance: string = null;
  medicalHome: string = null;
  newToPractice: boolean;
  memberStatusReason: string;
  ccmStatus: string;
  dualStatus: boolean;
  srcEntityType: string;
}

export enum PatientStatus {
  LIFESTYLEMANAGEMENT = 'LIFESTYLEMANAGEMENT',
  ACUTECONDITION = 'ACUTECONDITION',
  CRITICALCARE = 'CRITICALCARE',
  EMERGENCYROOM = 'EMERGENCYROOM',
  ENDOFLIFE = 'ENDOFLIFE',
  HOSPICE = 'HOSPICE',
  REHAB = 'REHAB',
  DISCHARGED = 'DISCHARGED'
}

export enum PatientEligibilityStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export class PatientSearchRow {
  memberId: string;
  displayId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  sex: string;
  sexOther: string;
  dob: Date;
  dobString: string;
  age: string;
  medicalHome: string;
}

export class PatientSearchRowMapper implements RowMapper<Patient, PatientSearchRow> {
  constructor(private datePipe: CustomDatePipe) {}

  mapRows(values: Patient[]): PatientSearchRow[] {
    if (values?.length) {
      return values.map((v) => {
        return this.mapRow(v);
      });
    }

    return [];
  }

  public mapRow(patient: Patient) {
    const row = new PatientSearchRow();
    row.memberId = patient.memberId;
    row.displayId = patient.displayId;
    row.firstName = patient.firstName;
    row.lastName = patient.lastName;
    row.sex = patient.sex;
    row.age = patient.age;
    row.sexOther = patient.sexOther;

    if (patient.dob) {
      row.dob = patient.dob;
      row.dobString = this.datePipe.transform(patient.dob, DATE_FORMAT, 'UTC');
    }

    row.fullName = patient.firstName + ' ' + patient.lastName;

    row.medicalHome = patient.medicalHome;
    return row;
  }
}
